<template>
  <div>
    <SkeletonCard v-if="loading"></SkeletonCard>
    <div v-else>
      <div v-if="!site_uuid">
        <LatestAnalysis :data="data"></LatestAnalysis>
        <div class="headSectionIA">
      <span class="name">
        <translate>Prompts</translate>
      </span>
          <div class="groupText">
            <span class="first"><translate>It displays the prompts used in the last brand analysis, the response in each LLM, and the sentiment. You can edit, add, or delete prompts to generate a new analysis.</translate></span>
          </div>
          <span class="text-12"></span>
        </div>
        <p class="text-13 mt-[16px]">
          <translate>
            The prompts are classified into %{numberPromptsIndirect} indirect (without naming the brand), %{numberPromptsDirect} direct (when the brand is named) and %{numberPromptsDirect} direct with sector dimension (%{numberPromptsDirectSectorial} for each sector dimension). You can add or modify the prompts to generate a new analysis.
            </translate></p>

      </div>

        <div class="box p-0">
          <div v-if="site_uuid"
               class="tw-flex gap-2 items-start p-[20px]">

            <div class="flex-1">
              <div class="tw-flex gap-4 font-semibold ">
                <span><translate>GeoPrompts from</translate></span>
                <span class="text-purple">{{ fullName }}</span>
              </div>
              <p class="text-[13px] mt-[20px]"><translate>Prompts are classified as Direct (when the brand is named), Direct with sector dimension (for each sector dimension) and Indirect (without naming the brand). You can add or modify prompts to generate a new analysis.</translate></p>
              <p class="text-[13px]"><translate>Changes to prompts and analysis results will be applied in the next generation of analysis.</translate></p>
            </div>

          </div>
          <div class="tw-flex gap-2 items-center px-[16px] py-[12px]">
            <span class="text-14"><translate>Review your Prompts</translate></span>
            <div class="boxSearchQuestions">
              <span v-if="1!=1"><translate>Search Prompts</translate></span>
              <input type="text" v-model="search" :placeholder="$gettext('Search Prompts')">
              <button class="absolute">
                <img src="@/assets/img/IAReputation/search.svg" />
              </button>
            </div>
          </div>

          <div class="bg-[#EDE8FF] border-b border-[#8A8A8A] tw-flex items-center gap-2 py-[12px] px-[16px] grid grid-cols-[minmax(0,051fr)_minmax(0,6fr)_minmax(0,2fr)_minmax(0,025fr)]">
            <button :class="{'-rotate-90': !showPromptsIndirect}" @click="showPromptsIndirect = !showPromptsIndirect">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.121" height="9.311" viewBox="0 0 17.121 9.311">
                <path id="vector" d="M0,0,7.5,7.5,15,0" transform="translate(1.061 1.061)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
              </svg>

            </button>
            <span class="text-14 font-bold"><translate>Indirect Prompts (%{promptsIndirect.length}):</translate></span>
            <div class="">

            </div>
            <div class=""></div>
          </div>
          <div v-if="showPromptsIndirect">
            <Prompt v-for="(item, index) in promptsIndirect"
                    :key="index"
                    :data="data"
                    :item="item"
                    :isProcessing="isProcessing"
                    @onSave="saveEditingPrompt($event)"
                    @onConfirmDelete="deletePrompt(item)"
            >
              <div v-if="!item.edited" class="tw-flex gap-2 items-start">
                <div class="tw-flex items-center gap-2">

                </div>
                <div  style="margin-left: 52px" class="tw-flex gap-2 flex-wrap">
                  <div v-for="(llm, indexllm) in llms" :key="indexllm" class="tw-flex flex-col gap-2" :class="{'notFound': getNotExistLLM(data,llm)}">
                    <div class="tw-flex flex-col gap-2 icoLLM text-center items-center justify-center w-[26px]">
                      <img :src="getLogoByLLM(llm, true)" class="h-[16px]" alt=""  />

                    </div>
                    <img :src="verifyIndirectPromptsVisibility(item.text, llm)" class="h-[14px]" alt=""  />
                  </div>
                </div>
              </div>
              <Pending v-else></Pending>
            </Prompt>

          </div>

          <div class="bg-[#EDE8FF] border-b border-[#8A8A8A] tw-flex items-center gap-2 py-[12px] px-[16px] grid grid-cols-[minmax(0,051fr)_minmax(0,6fr)_minmax(0,2fr)_minmax(0,025fr)]">
            <button :class="{'-rotate-90': !showPromptsDirect}" @click="showPromptsDirect = !showPromptsDirect">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.121" height="9.311" viewBox="0 0 17.121 9.311">
                <path id="vector" d="M0,0,7.5,7.5,15,0" transform="translate(1.061 1.061)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
              </svg>

            </button>
            <span class="text-14 font-bold"><translate>Direct prompts (%{promptsDirect.length}):</translate></span>
            <div class="tw-flex px-[16px]">
              <span class="text-12 flex-1"><translate>Sentiment in Responses</translate></span>
              <button @click="orderDirect = orderDirect === 'asc' ? 'desc' : 'asc'">
                <img src="@/assets/img/IAReputation/order.svg" :class="{'rotate-180': orderDirect !== 'asc'}" />
              </button>
            </div>
            <div class=""></div>
          </div>
          <div v-if="showPromptsDirect">
            <Prompt v-for="(item, index) in promptsDirectOrdered"
                    :key="index"
                    :data="data"
                    :isProcessing="isProcessing"
                    @onSave="saveEditingPrompt($event)"
                    @onConfirmDelete="deletePrompt(item)"
                    :item="item">
              <div v-if="!item.edited" class="tw-flex gap-2 items-start">
                <div class="tw-flex items-center gap-2 min-w-[48px]">
                  <img :src="getImageByScoreLLM(item.avg_score)" class="h-[14px]" alt=""  />
                  <span :style="{color: getColorByScore(item.avg_score)}" class="font-semibold text-13">
                {{ item.avg_score | formatNumber(2,2) }}
              </span>
                </div>
                <div class="tw-flex gap-2 flex-wrap">
                  <div v-for="(llm, indexllm) in llms" :key="indexllm" class="tw-flex flex-col gap-2">
                    <div class="tw-flex flex-col gap-2 icoLLM text-center items-center justify-center w-[26px]" :class="{'notFound': getNotExistLLM(data,llm)}">
                      <img :src="getLogoByLLM(llm, true)" class="h-[16px]" alt=""  />
                    </div>
                    <img v-if="!getNotExistLLM(data, llm)" :src="getImageByScoreLLM(getScoreByQuestionDirectByLLM(llm, item.text))" class="h-[14px]" alt=""  />
                  </div>
                </div>
              </div>
              <Pending v-else></Pending>
            </Prompt>
          </div>

          <div class="bg-[#EDE8FF] border-b border-[#8A8A8A] tw-flex items-center gap-2 py-[12px] px-[16px] grid grid-cols-[minmax(0,051fr)_minmax(0,6fr)_minmax(0,2fr)_minmax(0,025fr)]">
            <button :class="{'-rotate-90': !showPromptsDirectSectorial}" @click="showPromptsDirectSectorial = !showPromptsDirectSectorial">
              <svg xmlns="http://www.w3.org/2000/svg" width="17.121" height="9.311" viewBox="0 0 17.121 9.311">
                <path id="vector" d="M0,0,7.5,7.5,15,0" transform="translate(1.061 1.061)" fill="none" stroke="#000" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
              </svg>

            </button>
            <span class="text-14 font-bold"><translate>Direct Prompts with sectoral dimension (%{promptsDirectSectorial.length}):</translate></span>
            <div class="px-[16px]">
              <div class="tw-flex">
                <span class="text-12 flex-1"><translate>Sentiment in Responses</translate></span>
                <button @click="orderDirectSectorial = orderDirectSectorial === 'asc' ? 'desc' : 'asc'">
                  <img src="@/assets/img/IAReputation/order.svg" :class="{'rotate-180': orderDirectSectorial !== 'asc'}" />
                </button>
              </div>
            </div>
            <div class=""></div>
          </div>
          <div v-if="showPromptsDirectSectorial">
            <Prompt v-for="(item, index) in promptsDirectSectorialOrdered"
                    :key="index"
                    :item="item"
                    :data="data"
                    :isProcessing="isProcessing"
                    @onSave="saveEditingPrompt($event)"
                    @onConfirmDelete="deletePrompt(item)"
            >
              <div v-if="!item.edited" class="tw-flex gap-2 items-start">
                <div class="tw-flex items-center gap-2 min-w-[48px]">
                  <img :src="getImageByScoreLLM(item.avg_score)" class="h-[14px]" alt=""  />
                  <span :style="{color: getColorByScore(item.avg_score)}" class="font-semibold text-13">
                  {{ item.avg_score | formatNumber(2,2) }}
                </span>
                </div>
                <div class="tw-flex gap-2 flex-wrap">
                  <div v-for="(llm, indexllm) in llms" :key="indexllm" class="tw-flex flex-col gap-2">
                    <div class="tw-flex flex-col gap-2 icoLLM text-center items-center justify-center w-[26px]" :class="{'notFound': getNotExistLLM(data,llm)}">
                      <img :src="getLogoByLLM(llm, true)" class="h-[16px]" alt=""  />
                    </div>
                    <img v-if="!getNotExistLLM(data, llm)" :src="getImageByScoreLLM(getScoreByQuestionDirectByLLM(llm, item.text))" class="h-[14px]" alt=""  />
                  </div>
                </div>
              </div>
              <Pending v-else></Pending>
            </Prompt>

          </div>

          <!-- CREAMOS CAJA PARA AÑADIR PROMPTS -->
          <div v-if="!isProcessing && canEditPrompt" class="boxAddPrompt">
            <span class="hidden"><translate>Add your custom prompts here or add them later.</translate></span>
            <textarea v-model="newPrompt" :placeholder="$gettext('Add your custom prompts here or add them later.')"></textarea>
            <select v-model="typeNewPrompt" class="type">
              <option v-for="(option, index) in typesNewPrompts" :key="index" :value="option.id">{{ option.name }}</option>
            </select>
            <select v-if="typeNewPrompt === 'direct'"
                    v-model="newDimension"
                    class="dimension" :placeholder="$gettext('Dimension')">
              <option v-for="(option, index) in dimensions" :key="index" :value="option">{{ option }}</option>
            </select>
            <button :class="{'not-valid': !newPromptIsValid}" @click="addNewPrompt">
              <svg xmlns="http://www.w3.org/2000/svg" width="12.121" height="15.81" viewBox="0 0 12.121 15.81">
                <path id="Vector" d="M5.25,10,0,5M0,5,5.25,0M0,5H14" transform="translate(11.06 1.06) rotate(90)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
              </svg>
            </button>
          </div>

          <div class="boxInfo">
            <svg xmlns="http://www.w3.org/2000/svg" width="26.999" height="27" viewBox="0 0 26.999 27">
              <g id="Grupo_24181" data-name="Grupo 24181" transform="translate(-558.874 -1529.5)">
                <path id="Trazado_18278" data-name="Trazado 18278" d="M440.25,81V92.255" transform="translate(125.955 1458.672)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Trazado_18279" data-name="Trazado 18279" d="M444,83v8.441" transform="translate(127.481 1459.486)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Trazado_18280" data-name="Trazado 18280" d="M447.75,86v4.22" transform="translate(129.007 1460.707)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Trazado_18281" data-name="Trazado 18281" d="M458.964,85.906v8.705a4.352,4.352,0,0,1-4.353,4.352H440.1a4.353,4.353,0,0,1-4.353-4.353V80.1A4.353,4.353,0,0,1,440.1,75.75h8.7" transform="translate(124.124 1456.536)" fill="none" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="2"/>
                <path id="Trazado_18282" data-name="Trazado 18282" d="M452.516,83.213l-.936,2.85a.625.625,0,0,1-1.187,0l-.936-2.85a1.874,1.874,0,0,0-1.2-1.2l-2.85-.935a.625.625,0,0,1,0-1.188l2.85-.935a1.874,1.874,0,0,0,1.2-1.2l.936-2.85a.625.625,0,0,1,1.187,0l.936,2.85a1.874,1.874,0,0,0,1.2,1.2l2.85.935a.625.625,0,0,1,0,1.188l-2.85.935A1.874,1.874,0,0,0,452.516,83.213Z" transform="translate(127.88 1456.02)" fill="#fff" stroke="#fff" stroke-width="2"/>
              </g>
            </svg>
            <div class="text">
              <span><translate>NOTICE</translate></span>
              <br>
              <p>Los cambios en los prompts y resultados del análisis se aplicarán en la próxima generación del análisis.</p>
              <!--<p><translate>Next scheduled analysis:</translate> <strong>03/10/2025</strong></p>-->
            </div>
          </div>

          <button v-if="1!=1" class="opacity-50 cursor-not-allowed generateAnalysis" >
            Generar análisis de la marca
            <svg xmlns="http://www.w3.org/2000/svg" width="15.81" height="12.121" viewBox="0 0 15.81 12.121">
              <path id="Vector" d="M5.25,0,0,5M0,5l5.25,5M0,5H14" transform="translate(14.75 11.06) rotate(180)" fill="#fff" stroke="#fff" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5"/>
            </svg>
          </button>
        </div>
    </div>
  </div>
</template>

<script>
import LatestAnalysis from "@/components/IAReputation/LatestAnalysis.vue"
import MixinIAReputation from "@/mixins/iareputation.js"
import SrvIAReputationService from "@/services/iareputation.js"
import Prompt from '@/components/IAReputation/Prompt.vue'
import Pending from '@/components/IAReputation/Pending.vue'
import SkeletonCard from '@/components/common/skeletonCard.vue'

export default {
  components: {LatestAnalysis, Prompt, Pending, SkeletonCard},
  props: {
    site_uuid: {
      default: null,
    },
    fullName: {
      default: null
    }
  },
  mixins: [MixinIAReputation],
  data() {
    return {
      data: null,
      showPromptsDirect: false,
      showPromptsDirectSectorial: false,
      showPromptsIndirect: false,
      search: null,
      orderDirect: 'desc',
      orderDirectSectorial: 'desc',
      prompts: {direct: [], indirect: [], sectorial: [], directAll: []},
      loading: false,
      typesNewPrompts: [{id: 'direct', name: 'Directo'}, {id: 'indirect', name: 'Indirecto'}],
      typeNewPrompt: 'direct',
      newDimension: null,
      newPrompt: null,
      dataPrompts: null,
      dataBrand: null
    }
  },
  mounted(){
    this.getData()
  },
  methods: {
    async getData () {
      try {
        this.loading = true
        const [resReputation, resPrompts, resBrand] = await Promise.all([
          SrvIAReputationService.getReputation({brand_uuid: this.brandUUID, site_uuid: this.site_uuid}),
          SrvIAReputationService.getPrompts({brand_uuid: this.brandUUID, site_uuid: this.site_uuid}),
          SrvIAReputationService.getBrand({brand_uuid: this.brandUUID, site_uuid: this.site_uuid}),
        ])
        if (resReputation.status === 200 && resPrompts.status === 200 && resBrand.status === 200) {
          this.data = resReputation.data
          this.dataPrompts = resPrompts.data
          this.dataBrand = resBrand.data
          this.regenerateIds()
        }
        this.loading = false
      } catch (e) {
        console.log(e)
      }
    },
    regenerateIds () {
      // MAPEAMOS LOS PROPMTS PARA DARLE EL PROMPT_ID PARA CUANDO EDITEMOS O ELIMINEMOS
      let promptsDirect = this.dataPrompts.prompts.direct.map((e,index) => {
        e = {...e, prompt_id: index,
          avg_score: this.getTotalAvgScoreByPrompt(e.text, 'direct'),
          showMenu: false,
          editing: false,
          edited: this.setEdited(e, 'direct'),
          prompt_type: 'direct'}
        return e
      })
      this.prompts.directAll = promptsDirect
      this.prompts.direct = promptsDirect.filter(e => e.type === 'generic' || e.dimension === 'global')
      this.prompts.sectorial = promptsDirect.filter(e => e.type !== 'generic' && e.dimension !== 'global')
      this.prompts.indirect = this.dataPrompts.prompts.indirect.map((e,index) => {
        e = {...e, prompt_id: index,
          //avg_score: this.getTotalAvgScoreByPrompt(e.text, 'indirect'),
          showMenu: false,
          editing: false,
          edited: this.setEdited(e, 'indirect'),
          prompt_type: 'indirect'}

        return e
      })
    },
    setEdited (prompt, type) {
      const llmsExist = Object.keys(this.data.reputation_index).filter(e => e !== 'aggregated_google_alignment_ia')
      let found = true
      llmsExist.forEach(llm => {
        //buscamos el prompt en
        if (this.data.reputation_index[llm].prompts_answers[type].filter(e => e.text === prompt.text).length === 0) {
          found = false
        } else {
          found = true
        }
      })
      return !found
    },
    async deletePrompt(item) {
      console.log(item)
      try {
        const { status } = await SrvIAReputationService.deletePrompt({
          brand_uuid: this.brandUUID, site_uuid: this.site_uuid, type: item.prompt_type, prompt_id: item.prompt_id})
        if (status === 200) {
          if (item.prompt_type === 'direct') {
            if (item.dimension === 'global') {
              this.prompts.direct.splice(item.prompt_id, 1)
            } else {
              this.prompts.sectorial.splice(item.prompt_id,1)
            }
            this.prompts.directAll.splice(item.prompt_id,1)
            this.dataPrompts.prompts.direct.splice(item.prompt_id,1)
          } else if (item.prompt_type === 'indirect') {
            this.prompts.indirect.splice(item.prompt_id,1)
            this.dataPrompts.prompts.indirect.splice(item.prompt_id,1)
          }

          this.regenerateIds()
        }
      } catch (e) {
        console.log(e)
      }
    },
    async saveEditingPrompt(item) {
      item.editing = false
      try {
        const { status } = await SrvIAReputationService.setPrompt({
          brand_uuid: this.brandUUID, site_uuid: this.site_uuid, type: item.prompt_type, prompt_id: item.prompt_id, text: item.text, method: 'put'
        })
        if (status === 200) {
          item.edited = this.setEdited(item, item.prompt_type)
        }
      } catch (e) {
        console.log(e)
      }
    },
    async addNewPrompt() {
      try {
        let dimension = this.newDimension
        if (this.typeNewPrompt === 'direct' && !this.newDimension) { dimension = "global" }
        let prompt = {
          brand_uuid: this.brandUUID, site_uuid: this.site_uuid, type: this.typeNewPrompt, text: this.newPrompt, method: 'post', dimension: dimension
        }

        const { status } = await SrvIAReputationService.setPrompt({...prompt, method: 'post' })
        if (status === 201) {
          console.log(`Llegamos a crear `, prompt, dimension)
          if (this.typeNewPrompt === 'indirect') {
            this.prompts.indirect.push(prompt)
            this.dataPrompts.prompts.indirect.push(prompt)
          } else {
            this.prompts.directAll.push(prompt)
            if (dimension && dimension !== 'global') {
              console.log(dimension)
              this.prompts.sectorial.push(prompt)
            } else {
              this.prompts.direct.push(prompt)
            }
            this.dataPrompts.prompts.direct.push(prompt)
          }
          this.regenerateIds()
          this.typeNewPrompt = 'direct'
          this.newPrompt = null
          this.newDimension = null
        }
      } catch (e) {
        console.log(e)
      }
    },
    getTotalAvgScoreByPrompt (prompt, type) {
      let sum = 0
      let count = 0
      const llmsExist = Object.keys(this.data.reputation_index).filter(e => e !== 'aggregated_google_alignment_ia')
      llmsExist.forEach(llm => {
        //buscamos el prompt en
        let items = this.data.reputation_index[llm].prompts_answers[type].filter(e => e.text === prompt)
        console.log(items)
        if (items.length > 0
          && !Object.keys(items[0].metrics_analysis.sentiment).includes('error')) {
          sum += this.data.reputation_index[llm].prompts_answers[type].filter(e => e.text === prompt)[0].metrics_analysis.sentiment?.score

        }
        count++
      })
      return sum / count
    }
  },
  computed: {
    canEditPrompt () {
      return this.$store.getters.getUserInfo?.change_IA_prompt
    },
    isProcessing () {
      if (!this.dataBrand) return true
      return this.dataBrand.is_processing
    },
    newPromptIsValid() {
      if (this.typeNewPrompt === 'direct' && this.newPrompt) {
        return true
      }
      if (this.typeNewPrompt === 'indirect' && this.newPrompt && this.newDimension) {
        return true
      }
      return false
    },
    numberPromptsDirect () {
      return this.promptsDirect.length
    },
    numberPromptsDirectSectorial () {
      return this.dimensions.length
    },
    numberPromptsIndirect () {
      return this.promptsIndirect.length
    },
    promptsDirect () {
      if (!this.data) return []
      if (this.search) {
        return this.prompts.direct.filter(e => e.text.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
      }
      return this.prompts.direct
    },
    promptsDirectOrdered () {
      const val = o => Number(o?.avg_score ?? o?.avg_score) || 0
      let items = (this.promptsDirect || [])
        .map((x, i) => ({ x, i, v: val(x) }))       // índice para desempate estable
        .slice()
        .sort((A, B) => (A.v - B.v) || (A.i - B.i)) // comparador numérico
        .map(o => o.x)
      if (this.orderDirect === 'desc') {
        items = items.reverse()
      }
      return items
    },
    promptsDirectSectorial () {
      if (!this.data) return []
      if (this.search) {
        return this.prompts.sectorial.filter(e => e.text.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
      }
      return this.prompts.sectorial
    },
    promptsDirectSectorialOrdered () {
      const val = o => Number(o?.avg_score ?? o?.avg_score) || 0
      let items = (this.promptsDirectSectorial || [])
        .map((x, i) => ({ x, i, v: val(x) }))       // índice para desempate estable
        .slice()
        .sort((A, B) => (A.v - B.v) || (A.i - B.i)) // comparador numérico
        .map(o => o.x)
      if (this.orderDirectSectorial === 'desc') {
        items = items.reverse()
      }
      return items
    },

    promptsIndirect () {
      if (!this.data) return []
      if (this.search) {
        return this.prompts.indirect.filter(e => e.text.toLowerCase().indexOf(this.search.toLowerCase()) > -1)
      }
      return this.prompts.indirect
    }
  }
}
</script>
<style>
.boxAddPrompt{
  border-radius: 18px;
  border: 1px solid #D5D5D5;
  padding: 10px;
  display: flex;
  margin: 20px 25px;
  gap: 0.5rem;
  textarea{
    flex: 1;
    resize: none;
    font-size: 14px;
  }
  select{
    border: 1px solid #EAEAEC;
    border-radius: 8px;
    height: 36px;
    text-align: left;
    padding: 0.5rem;
    font-size: 12px;
    &.type{
      width: 125px;
    }
    &.dimension{
      width: 100px;
    }
  }
  button{
    background-color: #000;
    border-radius: 18px;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 70px;
    .not-valid{
      background-color: #8A8A8A;
      cursor-pointer: not-allowed;
    }
  }
}

.boxInfo{
  background-color: #8367DF;
  border-radius: 18px;
  padding: 35px;
  font-size: 14px;
  color: #fff;
  display: flex;
  gap: 1rem;
  margin: 20px 25px;
  align-items: start;
}

.generateAnalysis{
  background-color: #000;
  border-radius: 18px;
  color: #fff;
  display: flex;
  gap: 0.5rem;
  align-items: center;
  margin: 0 auto;
  font-weight: semi-bold;
  font-size: 14px;
  padding: 9px 15px;
  margin-bottom: 20px;
}
</style>
